import type { ThemePalette } from '@shared-ui/theme/types'
import { createContext, type PropsWithChildren, useContext } from 'react'

type ThemeContextValue = {
  palette: ThemePalette
}

const ThemeContext = createContext<ThemeContextValue>({ palette: 'light' })

export function ThemeProvider({ palette, children }: PropsWithChildren<{ palette: ThemePalette }>) {
  return <ThemeContext.Provider value={{ palette }}>{children}</ThemeContext.Provider>
}

export function useThemeContext(): ThemeContextValue {
  return useContext(ThemeContext)
}

export function useCurrentColorPalette(): ThemePalette {
  return useThemeContext().palette
}
